var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"k-svg-line",class:_vm.css_class,style:(_vm.svg_style),on:{"click":_vm.line_clicked}},[_c('line',{style:(_vm.line_style),attrs:{"x1":_vm.x1,"x2":_vm.x2,"y1":_vm.y1,"y2":_vm.y2}})])}
var staticRenderFns = []

export { render, staticRenderFns }